
export default function initAsOAuth () {
    // this.init(); called on the hook instead..
    const syncStore = this.env.syncStore;
    const sessionSettings = this.env.page.sessionSettings;
    const sess = this.env.oauthSession;
    const languageStore = this.env.languageStore;
    console.log('initAsAuth() sessionSettings ', sessionSettings);
    console.log('initAsOAuth(): ', this.oauthSessionId);
    languageStore.setTranslations(sessionSettings.translations);
    /*
        DO NOT DELETE Reference of the Sync Required Params for Google and Outlook oauth.
        apiKey
        oauthSessionId
        browser
        calendar
        locale
    */

    // Only the URL value is trusted: it comes from the widget that started this
    // sync. Stored settings may belong to an earlier sync with another publisher.
    const publisherId = sess?.publisherId;
    syncStore.sync({
        ...sess,
        publisherId: publisherId != null ? String(publisherId) : undefined,
    });

    /*
    syncStore.sync({
        ...sessionSettings,
        calendar: sessionSettings.selectedCalendar,
        publisherId: `${sessionSettings.widget.publisherId}`,
    });
    */
}
